import { render, staticRenderFns } from "./QuestionPoolsGrid.vue?vue&type=template&id=106d2d24"
import script from "./QuestionPoolsGrid.vue?vue&type=script&lang=js"
export * from "./QuestionPoolsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports